import {fillFormInputs, handleApiForm, hideField, showField} from "../../../forms";
import {closeModal, openModal} from "../../../utilities";
import * as $ from "jquery";
import {toastAlert} from "../../../toastAlert";
import Spinner from "../../../spinner";
import axios from "axios";
import {confirmModal} from "../../../confirmModal";
import moment from "moment/moment";

export const financial_obligation_templates_page = () => {
    const table = $('[data-app-financial_obligation_templates="table"]');
    const tableApi = table.DataTable().api();
    const body = $('body');
    let currentId = null;

    table.on('draw.dt', function () {
        $('[data-bs-toggle="tooltip"]').each(function () {
            new bootstrap.Tooltip(this)
        })
    });

    /// Forms
    // Common

    $('#addFinancialObligation [name="amount"], #addFinancialObligation [name="payment_date"]').change(function () {
        $(this).attr('data-app-changed', 'true');
    })

    // Add template
    $('[data-bs-target="#addFinancialObligationTemplateModal"]').click(function () {
        $("#addFinancialObligationTemplate").find('[name="amount"], [name="payment_date"]').attr('data-app-changed', 'false');
    })

    function getStatusesByObligationType(obligationType) {
        let statuses = {};
        if (obligationType == 1) {
            statuses = {
                '1': 'Nie zapłacono',
                '2': 'Zapłacono',
            };
        } else if (obligationType == 2) {
            statuses = {
                '3': 'Nie rozliczono',
                '4': 'Rozliczono',
            };
        }
        return statuses;
    }

    function clearField(inputElement) {
        if (inputElement) {
            inputElement.value = '';
        }
    }

    function formatDate(dateString) {
        if (!dateString) return '-';
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;  // Format as dd/mm/yyyy
    }

    function handleObligationTypeChange() {
        const form = $('#addFinancialObligationTemplate');
        const obligationType = form.find('[name="financial_obligation_type_id"]').find(`option[value="${form.find('[name="financial_obligation_type_id"]').val()}"]`).attr('data-obligation_type');

        const typeCashInput = form.find('input[name="payment_date"]')[0];
        const typeHoursInput = form.find('input[name="deadline_date"]')[0];
        const amountLabel = document.getElementById('add_template_amount_label');

        if (obligationType == 1) {
            amountLabel.textContent = 'Kwota';
            hideField(form, 'deadline_date');
            showField(form, 'payment_date');
            clearField(typeHoursInput);
        } else if (obligationType == 2) {
            amountLabel.textContent = 'Liczba godzin';
            hideField(form, 'payment_date');
            showField(form, 'deadline_date');
            clearField(typeCashInput);
        }

        const statusSelect = form.find('[name="status"]');
        statusSelect.empty();

        const statuses = getStatusesByObligationType(obligationType);
        for (const [value, text] of Object.entries(statuses)) {
            statusSelect.append(new Option(text, value));
        }
    }

    function handleEditObligationTypeChange() {
        const form = $('#editFinancialObligationTemplate');
        const obligationType = form.find('[name="financial_obligation_type_id"]').find(`option[value="${form.find('[name="financial_obligation_type_id"]').val()}"]`).attr('data-obligation_type');

        const typeCashInput = form.find('input[name="payment_date"]')[0];
        const typeHoursInput = form.find('input[name="deadline_date"]')[0];
        const amountLabel = document.getElementById('edit_template_amount_label');

        if (obligationType == 1) {
            amountLabel.textContent = 'Kwota';
            hideField(form, 'deadline_date');
            showField(form, 'payment_date');
            clearField(typeHoursInput);
        } else if (obligationType == 2) {
            amountLabel.textContent = 'Liczba godzin';
            hideField(form, 'payment_date');
            showField(form, 'deadline_date');
            clearField(typeCashInput);
        }

        const statusSelect = form.find('[name="status"]');
        statusSelect.empty();

        const statuses = getStatusesByObligationType(obligationType);
        for (const [value, text] of Object.entries(statuses)) {
            statusSelect.append(new Option(text, value));
        }
    }

    $('#addFinancialObligationTemplateModal').on('shown.bs.modal', handleObligationTypeChange);

    $('#editFinancialObligationTemplateModal').on('shown.bs.modal', handleEditObligationTypeChange);


    $('#addFinancialObligationTemplate [name="financial_obligation_type_id"]').change(function () {
        const defaultAmount = $(this).find(`option[value="${$(this).val()}"]`).attr('data-default_amount');
        const defaultPaymentDate = $(this).find(`option[value="${$(this).val()}"]`).attr('data-default_payment_date');
        const form = $(this).closest('form');

        const amountInput = form.find('[name="amount"]');
        if (amountInput.attr('data-app-changed') !== "true") {
            amountInput.val(defaultAmount);
        }

        const paymentDate = form.find('[name="payment_date"]');
        if (paymentDate.attr('data-app-changed') !== "true" && defaultPaymentDate) {
            paymentDate.val(defaultPaymentDate);
        }
    }).change();

    $('#addFinancialObligationTemplate [name="financial_obligation_type_id"]').change(function () {
        const obligationType = $(this).find(`option[value="${$(this).val()}"]`).attr('data-obligation_type');
        const form = $(this).closest('form');

        const typeCashInput = document.querySelector('input[name="payment_date"]');
        const typeHoursInput = document.querySelector('input[name="deadline_date"]');

        const amountLabel = document.getElementById('add_template_amount_label');

        if (obligationType == 1) {
            amountLabel.textContent = 'Kwota';
            hideField(form, 'deadline_date');
            showField(form, 'payment_date');
            clearField(typeHoursInput);
        } else if (obligationType == 2) {
            amountLabel.textContent = 'Liczba godzin';
            hideField(form, 'payment_date');
            showField(form, 'deadline_date');
            clearField(typeCashInput);
        }

        const statusSelect = form.find('[name="status"]');
        statusSelect.empty();

        form.find('[name="deadline_date"]').val('');

        const statuses = getStatusesByObligationType(obligationType);
        for (const [value, text] of Object.entries(statuses)) {
            statusSelect.append(new Option(text, value));
        }

    }).change();

    $('#editFinancialObligationTemplate [name="financial_obligation_type_id"]').change(function () {
        const obligationType = $(this).find(`option[value="${$(this).val()}"]`).attr('data-obligation_type');
        const form = $(this).closest('form');

        const typeCashInput = document.querySelector('input[name="payment_date"]');
        const typeHoursInput = document.querySelector('input[name="deadline_date"]');

        const amountLabel = document.getElementById('edit_template_amount_label');

        if(obligationType == 1){
            amountLabel.textContent = 'Kwota';
            hideField(form,'deadline_date');
            showField(form,'payment_date');
            clearField(typeHoursInput);
        }
        else if(obligationType == 2){
            amountLabel.textContent = 'Liczba godzin';
            hideField(form,'payment_date');
            showField(form,'deadline_date');
            clearField(typeCashInput);
        }

        function clearField(inputElement) {
            if (inputElement) {
                inputElement.value = '';
            }
        }

        const statusSelect = form.find('[name="status"]');
        statusSelect.empty(); // Clear existing options

        form.find('[name="deadline_date"]').val('');

        const statuses = getStatusesByObligationType(obligationType);
        for (const [value, text] of Object.entries(statuses)) {
            statusSelect.append(new Option(text, value));
        }

    }).change();


    handleApiForm('#addFinancialObligationTemplate', ({response, form}) => {
        if (response.data.code === 200) {
            closeModal('#addFinancialObligationTemplateModal');
            fillFormInputs(form, {
                name: '',
                amount: '',
                payment_date: '',
                comments: ''
            })

            let template = response.data.financialObligationTemplate;
            let row = $(`
                <tr data-app-id="${template.id}">
                    <td>${template.name}</td>
                    <td>${template.type.name}</td>
                    <td>${template.moment_name}</td>
                    <td>${template.amount}</td>
                    <td>${template.payment_date ? template.payment_date : '-'}</td>
                    <td>${template.deadline_date ? formatDate(template.deadline_date) : '-'}</td>
                    <td>
                        ${template.comments.length > 0 ? `
                            <span title="${template.comments}" data-bs-toggle="tooltip">
                                <i class="fas fa-info-circle text-secondary"></i>
                            </span>
                        ` : `-`}
                    </td>
                    <td>
                        <button data-app-id="${template.id}" type="button" class="btn btn-sm btn-primary btnEditFinancialObligationTemplate">
                            Edytuj
                        </button>
                        <button data-app-id="${template.id}" type="button" class="btn btn-sm btn-danger btnDeleteFinancialObligationTemplate">
                            Usuń
                        </button>
                    </td>
                </tr>
            `)

            tableApi.rows.add(row);
            tableApi.draw();

            toastAlert('Pomyślnie dodano nowy szablon zobowiązania');
        }
    })

    // Edit template
    // load data

    body.on('click', '.btnEditFinancialObligationTemplate', async function() {
        const spinner = new Spinner();
        currentId = $(this).data('app-id');

        const form = $('#editFinancialObligationTemplate');

        try {
            const response = await axios.get(window.GET_FINANCIAL_OBLIGATION_TEMPLATE_URL.replace('ID', currentId));

            if (response.data.code !== 200) {
                if (response.data.errors) {
                    throw new Error();
                }

                return;
            }

            openModal('#editFinancialObligationTemplateModal')
            fillFormInputs(form, response.data.financialObligationTemplate);
        } catch(err) {
            toastAlert('Nie udało się załadować danych', {type: 'danger'})
        } finally {
            spinner.destroy()
        }
    })

    // handle form

    handleApiForm('#editFinancialObligationTemplate', ({response, form}) => {
        if (response.data.code === 200) {
            closeModal('#editFinancialObligationTemplateModal');
            fillFormInputs(form, {
                name: '',
                amount: '',
                payment_date: '',
                deadline_date: '',
                comments: ''
            })

            const template = response.data.financialObligationTemplate;

            let row = tableApi.$(`tr[data-app-id="${template.id}"]`);
            row.find(`td:nth-of-type(1)`).text(template.name);
            row.find(`td:nth-of-type(2)`).text(template.type.name);
            row.find(`td:nth-of-type(3)`).text(template.moment_name);
            row.find(`td:nth-of-type(4)`).text(template.amount);
            row.find(`td:nth-of-type(5)`).text(template.payment_date ?? '-');
            row.find(`td:nth-of-type(6)`).text(formatDate(template.deadline_date) ?? '-');

            if(template.comments.length > 0) {
                row.find(`td:nth-of-type(7)`).html(`
                    <span data-bs-toggle="tooltip" title="${template.comments}">
                        <i class="fas fa-info-circle text-secondary"></i>
                    </span>
                `);
            } else {
                row.find(`td:nth-of-type(7)`).text('-');
            }

            tableApi.row(row).invalidate();
            tableApi.draw();

            toastAlert('Pomyślnie zaktualizowano szablon zobowiązania');
        }
    }, (form) => {
        form.attr('action', window.FINANCIAL_OBLIGATION_TEMPLATE_EDIT_URL.replace('ID', currentId))
    })

    // Delete type

    body.on('click', '.btnDeleteFinancialObligationTemplate', async function() {
        let confirm = await confirmModal('Czy jesteś pewny/a, że chcesz usunąć ten szablon zobowiązania?', {color: 'danger'});
        if (!confirm) return;

        try {
            let url = window.FINANCIAL_OBLIGATION_TEMPLATE_DELETE_URL.replace('ID', $(this).data('app-id'));
            const response = await axios.post(url);

            if (response.data.code !== 200) {
                let err = new Error(response.data.errors);
                err.code = response.data.code;

                throw err;
            }

            let row = tableApi.$(`tr[data-app-id=${$(this).data('app-id')}]`)
            tableApi.row(row).remove().draw();

            toastAlert('Pomyślnie usunięto szablon zobowiązania');
        } catch (err) {
            if(err.code === 400) {
                toastAlert(err.message, {type: 'danger'})
                return;
            }

            toastAlert('Wystąpił błąd podczas próby usunięcia szablonu zobowiązania', {type: 'danger'})
        }
    })
}